import { faLock, faUnlockAlt } from "@fortawesome/pro-solid-svg-icons";
import cx from "classnames";
import React from "react";

import BlogPostVisibilityMenuTrigger from "@/mk2/apps/blogs/components/BlogPostVisibilityMenuTrigger";
import { BLOG_POST_VISIBILITY_MENU_MORE } from "@/mk2/apps/blogs/helpers";
import { MenuItem } from "@/mk2/components/menu/MenuItem";
import { Menu } from "@/mk2/containers/Menu/Menu";
import { BlogPostEntity, PostVisibility } from "@/mk2/schemas";
import {
    VISIBILE_FOR_AUTHENTICATED,
    VISIBILE_FOR_FRIENDS,
    VISIBILE_FOR_PUBLIC,
    VISIBILE_PRIVATE,
} from "@/mk/autogenerated/translation";

import styles from "./BlogPostVisibilityMenu.mscss";

interface OwnProps {
    className?: string;
    enabled: boolean;
    post: BlogPostEntity;

    onToggleMenuMore(postId: number);
    onSetVisibility(postId: number, visibility: PostVisibility);
}

type Props = OwnProps;

class BlogPostVisibilityMenu extends React.PureComponent<Props> {
    public render() {
        const { className, enabled, post } = this.props;

        return (
            <Menu
                className={cx(styles.BlogPostVisibilityMenu, className)}
                menuId={BLOG_POST_VISIBILITY_MENU_MORE(post.id)}
                trigger={
                    <BlogPostVisibilityMenuTrigger
                        onClick={this.handleOnToggleMenuMore}
                        enabled={enabled}
                        post={post}
                    />
                }
                triggerShadow={false}
            >
                <MenuItem
                    classNames={{
                        icon: styles.BlogPostVisibilityMenu__icon,
                        label:
                            post.visibility === PostVisibility.Public &&
                            styles.BlogPostVisibilityMenu__activeLabel,
                    }}
                    icon={faUnlockAlt}
                    label={VISIBILE_FOR_PUBLIC}
                    onClick={this.handleSetVisibilityPublic}
                />

                <MenuItem
                    classNames={{
                        icon: styles.BlogPostVisibilityMenu__icon,
                        label:
                            post.visibility === PostVisibility.Authenticated &&
                            styles.BlogPostVisibilityMenu__activeLabel,
                    }}
                    icon={faLock}
                    label={VISIBILE_FOR_AUTHENTICATED}
                    onClick={this.handleSetVisibilityAuthenticated}
                />

                {post.visibility === PostVisibility.Friends && (
                    <MenuItem
                        classNames={{
                            icon: styles.BlogPostVisibilityMenu__icon,
                            label:
                                post.visibility === PostVisibility.Friends &&
                                styles.BlogPostVisibilityMenu__activeLabel,
                        }}
                        label={VISIBILE_FOR_FRIENDS}
                        disabled
                    />
                )}

                {post.visibility === PostVisibility.Private && (
                    <MenuItem
                        classNames={{
                            icon: styles.BlogPostVisibilityMenu__icon,
                            label:
                                post.visibility === PostVisibility.Private &&
                                styles.BlogPostVisibilityMenu__activeLabel,
                        }}
                        label={VISIBILE_PRIVATE}
                        disabled
                    />
                )}
            </Menu>
        );
    }

    private handleOnToggleMenuMore = () => {
        const { onToggleMenuMore, post } = this.props;
        onToggleMenuMore(post.id);
    };

    private handleSetVisibilityPublic = () => {
        const { onSetVisibility, post } = this.props;
        onSetVisibility(post.id, PostVisibility.Public);
    };

    private handleSetVisibilityAuthenticated = () => {
        const { onSetVisibility, post } = this.props;
        onSetVisibility(post.id, PostVisibility.Authenticated);
    };
}

export default BlogPostVisibilityMenu;
